import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {onyx, white} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    position: 'absolute',
    alignItems: 'center',
    justifyContent: 'center',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: onyx + 'B3', // 'B3' is 70% of opacity
  },
  center: {
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
  behind: {
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
  },
  contentContainer: {
    backgroundColor: white,
    borderRadius: 3,
    marginHorizontal: indent * 2,
    marginBottom: indent * 4,
  },
  fullModalContainer: {
    backgroundColor: white,
    paddingTop: indent * 2,
    borderRadius: 3,
    width: '100%',
    height: '100%',
  },
  successModalContainer: {
    backgroundColor: white,
    paddingTop: indent * 2,
    borderRadius: 3,
    width: '100%',
    height: '100%',
    opacity: 0.9,
  },
  touchableBackground: {
    width: '100%',
    height: '100%',
  },
});
